import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const requestsPlugin = createPlugin({
  id: 'requests',
  routes: {
    root: rootRouteRef,
  },
});

export const RequestsPage = requestsPlugin.provide(
  createRoutableExtension({
    name: 'RequestsPage',
    component: () =>
      import('./components/RequestsPage').then(m => m.RequestsPage),
    mountPoint: rootRouteRef,
  }),
);
